const ESPACE_INSECABLE = '\u00a0';

export interface RequeteSlashFinale {
  debut: number;
  fin: number;
  requete: string;
  requeteRecherche: string;
}

export function normaliserTexteSaisie(texte: string): string {
  return texte.replace(/\u00a0/g, ' ').replace(/[\r\n]+/g, ' ');
}

/** Texte écrit dans le contentEditable.
 * Safari/iOS rend souvent une espace finale avec NBSP ; si on la remplace par une
 * espace normale dans le DOM, elle semble disparaître immédiatement. */
export function textePourChampSaisie(texte: string): string {
  return texte.replace(/ +$/g, (espaces) => ESPACE_INSECABLE.repeat(espaces.length));
}

function estEspace(caractere: string): boolean {
  return /\s/u.test(caractere);
}

function normaliserRechercheSlash(texte: string): string {
  return texte.trim().replace(/\s+/gu, ' ');
}

function normaliserComparaisonSlash(texte: string): string {
  return normaliserRechercheSlash(texte)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/** Fragment final "/..." encore en cours de saisie pour citer un contact.
 * Le slash doit être en début de texte ou après une espace. Les espaces internes
 * restent possibles pour chercher un nom complet, mais une espace finale ferme la
 * mention afin que "/Nom " redevienne du texte normal après sélection. */
export function detecterRequeteSlashFinale(
  texte: string,
  contactsDejaChoisis: string[] = [],
): RequeteSlashFinale | null {
  let debut = -1;
  for (let i = texte.length - 1; i >= 0; i--) {
    if (texte[i] !== '/') continue;
    if (i === 0 || estEspace(texte[i - 1] ?? '')) {
      debut = i;
      break;
    }
  }
  if (debut < 0) return null;

  const requete = texte.slice(debut + 1);
  if (requete.length > 0 && estEspace(requete[requete.length - 1] ?? '')) return null;
  if (requete.includes('@') || requete.includes('/')) return null;

  const requeteRecherche = normaliserRechercheSlash(requete);
  const requeteComparee = normaliserComparaisonSlash(requete);
  if (requeteComparee) {
    for (const contact of contactsDejaChoisis) {
      const contactCompare = normaliserComparaisonSlash(contact);
      if (!contactCompare) continue;
      if (requeteComparee === contactCompare || requeteComparee.startsWith(`${contactCompare} `)) {
        return null;
      }
    }
  }

  return { debut, fin: texte.length, requete, requeteRecherche };
}
